export default __webpack_public_path__ + "static/media/twitter.5a9d6ded.svg";